var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spin',{attrs:{"spinning":_vm.spinning,"delay":_vm.delay}},[_c('Icon',{style:(_vm.fontSize),attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }